import React from "react";

function isTrapCardCodeAvailable(code) {
    if (code == null || code === "") return false;

    const trimmed = String(code).trim();

    return (
        trimmed.length >= 3 &&
        trimmed !== "1" &&
        trimmed.toUpperCase() !== "NOT AVAILABLE"
    );
}

function parseTrapCardField(value) {
    if (value == null || value === "") return [];

    return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(isTrapCardCodeAvailable);
}

function formatDate(dateString) {
    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    if (hours === 0) hours = 12;

    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
}

const TRAP_CARD_POINTS = {
    A: 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    J: 11,
    Q: 12,
    K: 13
};

function trapCardPoints(code) {
    if (!isTrapCardCodeAvailable(code)) return 0;

    const rank = String(code).slice(0, -2);

    return TRAP_CARD_POINTS[rank] || 0;
}

function calcTrapScore(cards) {
    if (!cards.length) return "";

    return cards.reduce((sum, card) => sum + trapCardPoints(card), 0);
}

const TrapResult = ({ resultData }) => {
    return (
        <div className="left-content" style={{ marginRight: "5px", marginLeft: "5px" }}>

            {resultData?.map((row, index) => {

                const cardsA = parseTrapCardField(row.ac1);
                const cardsB = parseTrapCardField(row.ac2);

                return (

                    <div
                        key={index}
                        className="card trap-result-card"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            marginBottom: "4px",
                            background:
                                "linear-gradient(rgb(15,15,15), rgb(251,251,251))",
                            color: "white"
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                                marginTop: "10px",
                                marginLeft: "10px",
                                fontSize: "16px",
                                fontWeight: "bold",
                                width: "100%"
                            }}
                        >
                            <span>{formatDate(row.evt_od)}
                                <b> - ID = </b>
                                {row.evt_id || row._id}
                            </span>
                        </div>


                        <div className="card-body" style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                            padding: "6px "
                        }}>

                            {[

                                {
                                    label: "Player A",
                                    cards: cardsA,
                                    score: calcTrapScore(cardsA),
                                    winner:
                                        row.result === "1" ||
                                        row.result === 1
                                },

                                {
                                    label: "Player B",
                                    cards: cardsB,
                                    score: calcTrapScore(cardsB),
                                    winner:
                                        row.result === "2" ||
                                        row.result === 2
                                }

                            ].map((player) => (

                                <div
                                    key={player.label}
                                    className={
                                        player.winner
                                            ? "TdResults TdResultsWin"
                                            : "TdResults"
                                    }
                                >

                                    <div
                                        className="player-cards"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            overflowWrap: "break-word",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {player.label}


                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: "5px",
                                            flexWrap: "wrap"
                                        }}
                                    >

                                        {player.cards.map((card, i) => (

                                            <img
                                                key={i}
                                                src={`/assets/images/cards/${card}.svg`}
                                                alt=""
                                                draggable={false}
                                                style={{
                                                    width: "42px"
                                                }}
                                            />

                                        ))}

                                    </div>

                                    <div
                                        className={player.winner ? "bgWinner" : "bgLoser"}
                                        style={{
                                            color: "#000",
                                            marginTop: "5px",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            width: "100%"
                                        }}
                                    >
                                        {player.winner ? "WINNER" : "LOSER"}
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                );

            })}
            <style>
                {`
                    .bgWinner {
                        border-radius: 10px;
                        background-color: #cf8d2e !important;
                    }

                    .bgLoser {
                        border-radius: 10px;
                        background-color: #cf3f3f !important;
                    }
                `}
            </style>
        </div>
    );
};

export default TrapResult;